var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("122")]),_c('videoPlayer',{attrs:{"options":_vm.playerOptions,"playsinline":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }